import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { remove } from 'lodash';
import { Filter } from '../filter.model';

@Component({
  selector: 'app-filter-multi',
  templateUrl: './filter-multi.component.html',
  styleUrls: ['./filter-multi.component.scss']
})

export class FilterMultiComponent implements OnInit {
  @Input() filter: Filter;
  @Input() filterForm: UntypedFormGroup;
  @Output() filterChange = new EventEmitter<any>();
  public selection=[];

  constructor(
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {

    if (this.filter.selected){
      this.selection = this.filter.selected.value.map(selected =>{
        return this.filter.options.find(option => option.id === selected);
      })
    } else{
      this.selection.push(this.filter.options[0]);
    }
  }
  onSubmit(){
    this.filter.selected = this.filter.options[0];
    this.filter.selected.value = this.selection.map(item => item.id);

    const filterName = this.translateService.instant(this.filter.name);
    const filterValue = this.selection.map(item => item.label).join(', ');

    this.filter.selected.display = `${filterName}: ${filterValue}`;
    this.filterChange.emit(this.filter);
  }

  onChange(item, checked){
    if (checked){
      this.selection.push(item);
    } else {
      remove(this.selection, itemSelected => itemSelected.id === item.id);
    }
  }
}

